module.exports = __webpack_public_path__ + "static/img/irole.ac95e63.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/oo/irole.png
// module id = Res3
// module chunks = 7